import { Container } from '../components/Container'
import Header from '../components/Header'
import { shouldSkipLoginRecaptcha } from '../helpers/shouldSkipLoginRecaptcha'
import { useRouter } from 'next/router'
import { UserStore } from '../state/UserStore'
import { useEffect } from 'react'
import { GeneralAPI } from '../apis/GeneralAPI'
import LoginForm from '../components/Auth/LoginForm'
import OlcLoginForm from '../components/Auth/OlcLoginForm'
// import withoutAuthentication from '../hoc/withoutAuthentication'

/**
 * Once it does login
 * We save JWT details to Cookie
 * And everytime a request is made to restricated routes
 * it should go to
 */

export function Login({ data }) {
    const router = useRouter()
    const skipCaptcha = shouldSkipLoginRecaptcha()

    const redirectTo = router.query.redirectTo
    const handoffError = router.query.error
    const showHandoffError =
        handoffError === 'invalid_code' || handoffError === 'missing_code'

    const user = UserStore((state) => state.user)

    useEffect(() => {
        if (user?.ID) router.push('/my-account')
    }, [user, router])

    useEffect(() => {
        console.log('[login] env', {
            VERCEL_ENV: process.env.VERCEL_ENV,
            NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
            NODE_ENV: process.env.NODE_ENV,
            skipCaptcha,
        })
    }, [skipCaptcha])

    return (
        <div>
            <Header meta={data?.yoast_head} />
            <div className="min-h-screen bg-[#FAFAF9] bg-[radial-gradient(circle_at_15%_0%,rgba(237,92,47,0.06),transparent_45%),radial-gradient(circle_at_100%_100%,rgba(250,179,49,0.08),transparent_40%)]">
                <Container>
                    <div className="mx-auto -my-10 max-w-[980px] px-1 pt-12 pb-20 md:px-6">
                        <div className="mb-9 mt-2 text-center">
                            <h1 className="m-0 text-[26px] font-extrabold tracking-normal text-[#1A1D23]">
                                Log in to your account
                            </h1>
                            <p className="mt-2 text-[15px] text-[#6F7785]">
                                Open Letter Marketing and Open Letter Connect
                                use separate accounts. Enter your details below
                                for the one you use.
                            </p>
                            {showHandoffError && (
                                <div className="mx-auto mt-4 max-w-[520px] rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-[14px] font-medium text-red-700">
                                    Please sign in again.
                                </div>
                            )}
                        </div>

                        <div className="grid items-stretch gap-6 lg:grid-cols-2">
                            <section className="rounded-[20px] border border-black/10 bg-white px-6 py-8 shadow-[0_20px_50px_-20px_rgba(26,29,35,0.15)] md:px-[34px] md:py-9">
                                <span className="mb-3.5 inline-flex rounded-full bg-[#F1F2F4] px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.06em] text-[#6F7785]">
                                    Ecommerce ordering
                                </span>
                                <h2 className="m-0 text-[19px] font-bold text-[#1A1D23]">
                                    Open Letter Marketing
                                </h2>
                                <p className="mb-[18px] mt-1.5 text-[13.5px] leading-[1.5] text-[#6F7785]">
                                    Our ecommerce platform for direct mail
                                    orders. Fast, self-serve ordering, including
                                    one-off sends, with mailing minimums.
                                </p>
                                <ul className="mb-6 flex list-none flex-col gap-[7px] p-0 text-[12.5px] font-medium text-[#4A5160]">
                                    <li className="flex items-start gap-2">
                                        <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-[#7D8798]" />
                                        Fast, easy ordering for one-off sends
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-[#7D8798]" />
                                        Manage campaigns and order history
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-[#7D8798]" />
                                        Mailing minimums apply
                                    </li>
                                </ul>

                                <LoginForm
                                    submitLabel="Sign in to OLM"
                                    showDivider={false}
                                    formClassName="hs-form-exclude space-y-3.5"
                                    labelClassName="mb-1.5 block text-[12.5px] font-semibold text-[#4A5160]"
                                    inputClassName="h-10 w-full rounded-[10px] border border-black/10 bg-[#FBFBFA] px-3 text-[14px] text-[#3F454F] placeholder:text-gray-400 transition-all focus:border-[#F28230] focus:bg-white focus:outline-none focus:ring-4 focus:ring-[#F28230]/10"
                                    submitButtonClassName="relative mt-1 flex w-full justify-center rounded-full bg-[#1A1D23] px-4 py-3 text-[14px] font-semibold text-white transition-all shadow-sm hover:-translate-y-0.5 hover:brightness-105 hover:shadow-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400"
                                    forgotPasswordClassName="text-[12.5px] text-[#6F7785] transition hover:text-[#ED5C2F] hover:underline"
                                    forgotPasswordWrapperClassName="-mt-1 flex justify-end"
                                    createAccountText="New to OLM?"
                                    createAccountLinkText="Create an account"
                                    createAccountWrapperClassName="mt-[18px] text-center text-[13px] text-[#6F7785]"
                                    createAccountLinkClassName="font-semibold text-[#ED5C2F] hover:underline"
                                    onSuccess={() =>
                                        redirectTo
                                            ? router.push(redirectTo)
                                            : router.push('/my-account')
                                    }
                                />
                            </section>

                            <section className="rounded-[20px] border border-black/10 bg-[linear-gradient(180deg,#FFF9F1_0%,#FFFFFF_55%)] px-6 py-8 shadow-[0_20px_50px_-20px_rgba(26,29,35,0.15)] md:px-[34px] md:py-9">
                                <span className="mb-3.5 inline-flex rounded-full bg-[#FCE3CB] px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.06em] text-[#A64A1D]">
                                    Platform &amp; automation
                                </span>
                                <h2 className="m-0 text-[19px] font-bold text-[#1A1D23]">
                                    Open Letter Connect
                                </h2>
                                <p className="mb-[18px] mt-1.5 text-[13.5px] leading-[1.5] text-[#6F7785]">
                                    Our direct mail technology platform with no
                                    minimums. Built for automated sending,
                                    real-time tracking, and API-driven
                                    campaigns.{' '}
                                    <a
                                        href="/platform/pricing"
                                        className="whitespace-nowrap font-semibold text-[#ED5C2F] hover:underline">
                                        View OLC pricing
                                    </a>
                                </p>
                                <ul className="mb-6 flex list-none flex-col gap-[7px] p-0 text-[12.5px] font-medium text-[#4A5160]">
                                    <li className="flex items-start gap-2">
                                        <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-[#ED5C2F]" />
                                        Send any quantity, no minimums
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-[#ED5C2F]" />
                                        Real-time mail tracking &amp; response
                                        reporting
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-[#ED5C2F]" />
                                        Automation &amp; API ready
                                    </li>
                                </ul>

                                <OlcLoginForm />
                            </section>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default Login

function CheckIcon({ className }) {
    return (
        <svg
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true">
            <path d="M4 10l4 4 8-8" />
        </svg>
    )
}

export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/login')
    const data = page ? page[0] : {}
    return {
        props: { data },
        revalidate: 10, // In seconds
    }
}
